import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database.types';
import { readAppEnv } from './env';

export function createSupabaseClient() {
  const env = readAppEnv();
  return createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
    auth: {
      flowType: 'pkce',
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true,
    },
  });
}

/**
 * A client that can only ever speak as `anon`.
 *
 * Public bearer-token pages must not inherit a Hub session from localStorage:
 * their database functions are deliberately executable by anon and nobody
 * else. A separate non-persisting client keeps that contract true even when a
 * signed-in teammate opens the public link in the same browser.
 */
export function createPublicSupabaseClient() {
  const env = readAppEnv();
  return createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
    auth: {
      detectSessionInUrl: false,
      persistSession: false,
      autoRefreshToken: false,
    },
  });
}

export type SupabaseClient = ReturnType<typeof createSupabaseClient>;
